var map = {
	"./1.png": "bc39",
	"./10.png": "f0ad",
	"./2.png": "6631",
	"./3.png": "a144",
	"./4.png": "c9ea",
	"./5.png": "5aaa",
	"./6.png": "ba61",
	"./7.png": "81a1",
	"./8.png": "734d",
	"./9.png": "622d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "07a4";